import { proxy } from 'valtio'
import { CommonApi, ScreenTypeOption } from '../../generated'
import { apiConfig } from '../apiConfig'
import { getName } from '../util/getName'

export const screenTypesStore = proxy<{ items: ScreenTypeOption[] }>({
  items: [],
})

const api = new CommonApi(apiConfig)

export async function loadScreenTypes() {
  await api.getScreenTypes().then((result) => {
    screenTypesStore.items = result
  })
}

export function getScreenTypeName(id?: number, defaultValue?: string, isOther?: boolean) {
  if (id === undefined) return ``
  return getName(screenTypesStore.items, id, defaultValue, isOther)
}

/**
 * 指定された言語の専攻形式のみを取得
 */
export function getScreenTypesByLanguage(language: 'En' | 'Ja'): ScreenTypeOption[] {
  return screenTypesStore.items.filter((item) => item.language === language)
}
